'use client';

import { c as _c } from "react/compiler-runtime";
import type { UseNotificacaoSelfReturn } from '../hooks';
import { BackHeader } from './BackHeader';
import { PlanoCard } from './PlanoCard';
interface TrocarPlanoScreenProps {
  vm: UseNotificacaoSelfReturn;
}
export const TrocarPlanoScreen = t0 => {
  const $ = _c(10);
  const {
    vm
  } = t0;
  let t1;
  if ($[0] !== vm) {
    t1 = <BackHeader onVoltar={() => vm.goTo("revisao")} />;
    $[0] = vm;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <div className="mb-10 flex max-w-[640px] flex-col items-center gap-2 text-center"><h1 className="text-heading-dark text-2xl font-semibold sm:text-[32px]">Qual plano faz mais sentido para você?</h1><p className="text-label-muted text-base">Seus dados já preenchidos continuam salvos, é só escolher outro plano e voltar de onde parou.</p></div>;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== vm) {
    t3 = vm.planos.map(plano => {
      const atual = plano.tier === vm.planoTier;
      return <PlanoCard key={plano.tier} plano={plano} selecionado={atual} ctaLabel={atual ? "Continuar com o plano atual" : `Escolher ${plano.nome}`} ctaVariant={atual ? "brand-primary" : "neutral-secondary"} onCta={() => vm.trocarPlano(plano.tier)} />;
    });
    $[3] = vm;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== t3) {
    t4 = <div className="flex flex-1 flex-col items-center px-6 py-12 md:px-20 md:py-16">{t2}<div className="flex w-full max-w-[1120px] flex-wrap justify-center gap-5">{t3}</div></div>;
    $[5] = t3;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== t1 || $[8] !== t4) {
    t5 = <div className="flex min-h-screen w-full flex-col bg-white">{t1}{t4}</div>;
    $[7] = t1;
    $[8] = t4;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  return t5;
};